import fileLinks from './fileLinks';

export default fileLinks;
